import { render } from "./Loader.vue?vue&type=template&id=117ad843"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\tomda\\PhpstormProjects\\cerstve-urtzeno-hana-a.s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__